import React, { useState, useEffect, useContext} from 'react'
import { GlobalContext } from '../../Context/GlobalContext';
import Preview from "Components/Preview"
import PreviewSpecial from "Components/PreviewSpecial"
import { parseText, parseNumbers, parseLive } from "Helpers/parse";

const VideoItem = ({
  item,
  category,
  previewSpecial=false,
  color,
  onClick
}) => {
  const { viewerObj, thumbnailSize, config, darkMode } = useContext(GlobalContext);
  const [notAccessible, setNotAccessible] = useState(null);
  const [subscriptionsTiers, setSubscriptionsTiers] = useState(item?.metadata?.associatedSubscriptions);
  const temp_hideVideoViews = item?.switches?.hideViews?.selected
  const hideVideoViews= temp_hideVideoViews && temp_hideVideoViews == 'enabled' ? temp_hideVideoViews : false

  // Gives user visual feed back on if a video is free to view or apart of a sub
  useEffect(() => {
    setNotAccessible(false);
    const monetizedFile = item?.metadata?.associatedSubscriptions;
    // if a file is apart of a sub, check if the viewer has access rights 
    if (monetizedFile) {
      // check if the file has any active subscriptions associated with it
      if (Object.keys(monetizedFile).length === 0) return;
      const product_Id = viewerObj?.subscription?.product_Id; 
      const activeSub = item.metadata.associatedSubscriptions.hasOwnProperty(product_Id);
      // if the viewer doesn't have the correct sub apply decrease img brightness on thumbnail as visual feedback
      if (!activeSub) {
        setNotAccessible(true);
      };
    };
  }, [viewerObj?._id]);
  
  let PreviewComponent = previewSpecial ? PreviewSpecial : Preview
  let name = "";
  let description = "";
  let previewType = category;

  // item.type determines what values to use for name and description.
  switch(item.type) {
    case "playlist":
      name = item.name
      description = parseText(new Date(item.date))
      if(!previewType) {
        previewType = "playlists"
      };
      break;
    case "live":
      name = item.name
      description = !config.hideViews && !hideVideoViews && parseLive(item.views)
      if(!previewType) {
        previewType = "live"
      };
      break;
    default:
      // This case is usually for videos which have metadata and switches, but check just to be sure.
      let descriptionDate = new Date(item.date)
      if(
        item.switches 
        && item.switches.date 
        && item.switches.date.selected === "original date"
      ) {
        descriptionDate = new Date(item.original_date)
      }
      if(item.metadata) {
        name = item.metadata.filename
      } else {
        name = item.name
      };
      const viewCount = parseNumbers(item.views)
      description = (
        !config.hideViews && !hideVideoViews 
          ? `${viewCount} view${item.views > 1 ? "s" : ""}` 
          : ""
      )
      break;
  }

  let subscriptionNames = '';
  // create a string of the tier names together
  if (subscriptionsTiers) {
    const subscriptionKeys = Object.keys(subscriptionsTiers);
    for (let i = 0; i < subscriptionKeys.length; i++) {
      const subscriptionName = subscriptionsTiers[subscriptionKeys[i]].name;
      if (i === subscriptionKeys.length - 2) {
        subscriptionNames += ` ${subscriptionName}, or`;
      } else {
        subscriptionNames += ` ${subscriptionName}`;
        if (i !== subscriptionKeys.length - 1) {
          subscriptionNames += ',';
        }
      }
    }
  }
  
  return (
    <>
      {<div
        className="col-3 mb-3"
        onClick={() => onClick(notAccessible)}
        id={thumbnailSize}
      >
        <PreviewComponent
          type={previewType}
          item={item._id}
          file={item._id}
          color={color}
          notAccessible={notAccessible}
        />
        {subscriptionsTiers && notAccessible && 
          <div style={{color: 'green', fontWeight: 700}}>
            <i className="fa-solid fa-dollar-sign"></i>
            Subscribe to {subscriptionNames}  to watch
          </div>
        }
        {name}
        <div className={darkMode?"dark dt":"dt"}>
          {description}
        </div>
      </div>}
    </>
  )
}

export default VideoItem;
